import { RouteConfig } from '../types/route'

import { isRoute } from './isRoute'

/**
 * 排除非路由配置，比如按钮
 *
 * @param configs 路由配置
 * @returns 路由配置
 */
export const filterRoutes = (configs: RouteConfig[]): RouteConfig[] => {
  return configs.reduce((acc, { children, ...item }) => {
    const config: RouteConfig = item
    if (children) {
      children = filterRoutes(children)
    }
    // 真实的路由或布局节点
    if (isRoute(config)) {
      config.children = children
      acc.push(config)
      // 否则抛弃当前节点，只保留子节点
    } else if (children) {
      acc.push(...children)
    }
    return acc
  }, [] as RouteConfig[])
}
